/**
 * EMZI NEXUS V6.3 - SOA Drill API Client
 */
import { BACKEND_URL as API_BASE_URL } from '../utils/backendUrl';

export const startSOADrill = async (payload) => {
  const response = await fetch(`${API_BASE_URL}/api/soa/drill/start`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to start SOA drill');
  }

  return response.json();
};

export const submitSOAAnswer = async (payload) => {
  const response = await fetch(`${API_BASE_URL}/api/soa/drill/answer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to submit answer');
  }

  return response.json();
};

export const completeSOADrill = async (sessionId) => {
  const response = await fetch(`${API_BASE_URL}/api/soa/drill/complete?session_id=${sessionId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to complete drill');
  }

  return response.json();
};

export const getSOADrillHistory = async (userId, limit = 10) => {
  const response = await fetch(`${API_BASE_URL}/api/soa/drill/history/${userId}?limit=${limit}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to get drill history');
  }

  return response.json();
};
